import { Link } from "react-router-dom";
import { LEGAL_ENTITY, LEGAL_EMAIL } from "../lib/legalContent";

export default function SiteFooter() {
  return (
    <footer className="border-t border-amber-100 bg-[#FFFDF7] px-6 py-6" data-testid="site-footer">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-500">
        <span data-testid="footer-copyright">© {new Date().getFullYear()} {LEGAL_ENTITY}. All rights reserved.</span>
        <nav className="flex flex-wrap items-center gap-5">
          <Link to="/terms" data-testid="footer-terms-link" className="font-semibold hover:text-[#FF5A79] transition-colors">Terms &amp; Conditions</Link>
          <Link to="/privacy" data-testid="footer-privacy-link" className="font-semibold hover:text-[#FF5A79] transition-colors">Privacy Policy</Link>
          <a href={`mailto:${LEGAL_EMAIL}`} data-testid="footer-contact-link" className="hover:text-[#FF5A79] transition-colors">Contact</a>
        </nav>
      </div>
    </footer>
  );
}
